import Component from '../core/Component';
import $ from 'jquery';
import enquire from 'enquire.js';
import { queries } from '../core/config';
import { throttle } from 'lodash';

export default class FixedMenu extends Component
{
    constructor($element)
    {
        super($element);
        setTimeout(() => {

            this.offset = this.$element.offset().top;
            this.$parent = this.$element.parent();
            this.$window = $(window);
            this.start = this.offset;
            this.end = $('.main').height() + this.start - $('.section-form').height() - this.$element.height() - 520;
            this.height = $('.main').height();

            this.sections = [];
            var self = this;
            this.$links = this.$element.find('a');
            this.$links.each(function () {
                var selector = $(this).attr('href');
                self.sections[selector] = {};
                self.sections[selector].element = $(selector);
                self.sections[selector].offset = $(selector).offset().top;
                self.sections[selector].link = $(this);
            });
            this.sections = this.sections.sort(this.dynamicSort('offset'));
        }, 600)
    }

    prepare()
    {
        setTimeout(() => {
            enquire.register(queries.mediumUp, {
                match: () => {
                    this.attach();
                },
                unmatch: () => {
                    this.detach();
                }
            });
        }, 600)
    }

    destroy () {
        this.detach();
    }

    attach () {
        $(window).on('scroll', throttle(::this.onScroll, 16));
    }

    detach () {
        $(window).off('scroll', throttle(::this.onScroll, 16));
    }

    onScroll(event) {
        var scrollTop = $(window).scrollTop();
        if (scrollTop >= this.start && scrollTop <= this.end) {
            this.$element.addClass('is-fixed').removeClass('is-hidden');
            this.element.style.top = "";
        } else if (scrollTop < this.start) {
            this.$element.removeClass('is-fixed is-hidden');
            this.element.style.top = "";
        } else {
            this.$element.addClass('is-fixed is-hidden');
        }

        this.activateMenuItem(scrollTop)
    }

    activateMenuItem (scroll) {
        this.deactiveMenuItems();

        var active, offset = 0;
        for (var prop in this.sections) {
            if (this.sections[prop].offset-100 <= scroll && offset < this.sections[prop].offset) {
                active = prop;
                offset = this.sections[prop].offset;
            }
        }
        if (active) {
            this.sections[active].link.addClass('active');
        }
    }

    deactiveMenuItems () {
        this.$links.removeClass('active');
    }

    dynamicSort(property) {
        var sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }
}


// WEBPACK FOOTER //
// ./components/FixedMenu.js